<template>
  <OfflineLayout>
    <TabPanel>
      <ResetPasswordForm />
    </TabPanel>
  </OfflineLayout>
</template>

<script>
import ResetPasswordForm from "@/components/ResetPasswordForm";
import OfflineLayout from "@/layouts/OfflineLayout";
import TabPanel from "primevue/tabpanel";

export default {
  name: 'ResetPasswordView',
  components: {ResetPasswordForm, OfflineLayout, TabPanel}
}
</script>

<style scoped>

</style>
